// extracted by mini-css-extract-plugin
export default {"container":"_3Ydd4","small":"_3-jn5","medium":"HsjXG","big":"_3im8H","extraBig":"_3Te2x"};